import {forEach} from "lodash";

global.$ = global.jQuery = require('jquery');
import colorLib from '@kurkle/color';
// import { Chart } from 'chart.js';
// import * as pie from 'chart.js';

// import 'chartjs-adapter-moment';

import {format, parse, parseISO, endOfMonth, endOfYear, isWithinInterval} from 'date-fns';
import 'chartjs-adapter-date-fns';

/*
 * Datepicker
 */
import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';
import localeEs from 'air-datepicker/locale/es';
import localeDe from 'air-datepicker/locale/de';
import localeIt from 'air-datepicker/locale/it';
import localeFr from 'air-datepicker/locale/fr';

import 'air-datepicker/air-datepicker.css';

import { Utils, Chart, ArcElement, LineController, LineElement, BarController, BarElement, PieController, RadarController, PointElement, LinearScale, RadialLinearScale, CategoryScale, TimeSeriesScale, Title, Legend, Filler, Tooltip } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

import { createPopper } from '@popperjs/core';
import tippy, {roundArrow} from 'tippy.js';
import 'tippy.js/dist/svg-arrow.css';
import 'tippy.js/themes/translucent.css';

Chart.register(LineController, ArcElement, LineElement, BarController, BarElement, PieController, RadarController, PointElement, LinearScale, RadialLinearScale, CategoryScale, TimeSeriesScale, Title, Legend, Filler, Tooltip, ChartDataLabels);

// chartjs-plugin-datalabels

var charts = [];

export class DashboardView {

	constructor() {
		// alert(1)

		const _this = this

		_this.chartsData = []
		_this.defaultFilters = {
						dropdown: null,
						date: null
					}
		// $(window).on('resize', _.bind(_this.onWindowResize, this) );	

		this.tooltipDefaultConfig = {
			padding: 10,
			borderWidth: 0,
			cornerRadius: 0,
			bodySpacing: 10,
			titleFont: {
				size: 14
			},
			bodyFont: {
				size: 14
			},
		}

		
		window['dp'] = {};

		this.beforeInit = {
			beforeInit: function(chart, options) {
				// Get reference to the original fit function
				const originalFit = chart.legend.fit;

				// Override the fit function
				chart.legend.fit = function fit() {
					// Call original function and bind scope in order to use `this` correctly inside it
					originalFit.bind(chart.legend)();
					// Change the height as suggested in another answers
					this.height += 10;
				}
			}
		}

		_this.chartsRender();

		_this.tooltipRender();

		// alert(1)

		_this.filterSelect();

		_this.initDatepickers();


	}

	chartsRender() {

		const _this = this

		/*
	     * Dashboard - used on template-dashboard.php
	     */
		const pieCharts = document.querySelectorAll('.pieChart');
		if(pieCharts) {
			for (let el of pieCharts) {
				const dataVar = el.getAttribute('data-var'),
					data = JSON.parse(JSON.stringify(window[dataVar].data)),
					options = JSON.parse(JSON.stringify(window[dataVar].options)),
					schema = window[dataVar].schema,
					type = 'pie-chart',
					filters = _this.defaultFilters

				_this.chartsData.push({
					dataVar,
					data, 
					options,
					schema,
					type,
					filters
				})

				const config = {
					type: 'pie',
					data: data,
					options: {
						responsive: true,
						maintainAspectRatio: false,
						events: ['click', 'mousemove', 'mouseout'],
						onClick(e, a) {
							if ( schema.linked_component.enabled ) {
								document.location.href = schema.linked_component.url + '?soft-filter[' + schema.linked_component.url_key_name + ']=' + e.chart.data.labels[a[0].index] + '&env=' + schema.linked_component.env
							}
							return;
						},
						plugins: {
							tooltip: {
								..._this.tooltipDefaultConfig,
								enabled: options.labels_type == 'tooltip',
								callbacks: {
									label: function(ctx) {
										let sum = 0;
										let dataArr = ctx.chart.data.datasets[0].data;

										dataArr.map(data => {
											sum += parseInt(data.value);
										});

										let val = options.labels_scale == 'percentage' ?(ctx.dataset.data[ctx.dataIndex] * 100 / sum).toFixed(2) + '%' : ctx.dataset.data[ctx.dataIndex].value;

										let label = ' ' + ctx.label +
											' ' + val || '';

										return label;
									}
								}
							},

							legend: {
								// position: 'right',
								labels: {
									padding: 5,
								}
							},

							datalabels: {
								display: options.labels_type == 'datalabel',
								formatter: (value, ctx) => {
									let sum = 0;
									let dataArr = ctx.chart.data.datasets[0].data;

									dataArr.map(data => {
										sum += parseInt(data.value);
									});

									let percentage = (value.value*100 / sum).toFixed(2)+"%";

									let result = options.labels_scale == 'percentage' ? percentage : ctx.chart.data.datasets[0].data[ctx.dataIndex].value;

									return (result != '0.00%' && result != '0') ? result : ''

								},
								color: '#fff',
							},

						}
					},
					plugins: [ this.beforeInit ]
				};

				const chart = new Chart(el.getContext('2d'), config)

				charts.push(chart);
			}
		}

		const doughnutCharts = document.querySelectorAll('.doughnutChart');
		if (doughnutCharts) {
			for (let el of doughnutCharts) {
				const dataVar = el.getAttribute('data-var'),
					data = JSON.parse(JSON.stringify(window[dataVar].data)),
					options = JSON.parse(JSON.stringify(window[dataVar].options)),
					schema = window[dataVar].schema,
					type = 'doughnut-chart',
					filters = _this.defaultFilters

				_this.chartsData.push({
					dataVar,
					data, 
					options,
					schema,
					type,
					filters
				})

				const config = {
					type: 'doughnut',
					data,
					options: {
						responsive: true,
						maintainAspectRatio: false,
						legend: {
							position: 'right',
						},

						events: ['click', 'mousemove', 'mouseout'],
						onClick(e, a) {

							// e.preventDefault()
							// console.log()
							if ( schema.linked_component.enabled ) {
								document.location.href = schema.linked_component.url + '?' + '?soft-filter[' + schema.linked_component.url_key_name + ']=' + e.chart.data.labels[a[0].index] + '&env=' + schema.linked_component.env
							}
							return;
						},
						plugins: {
							tooltip: {
								..._this.tooltipDefaultConfig,
								enabled: options.labels_type == 'tooltip',
								callbacks: {
									label: function(ctx) {
										let sum = 0;
										let dataArr = ctx.chart.data.datasets[0].data;

										dataArr.map(data => {
											sum += parseInt(data.value);
										});

										let val = options.labels_scale == 'percentage' ?(ctx.dataset.data[ctx.dataIndex] * 100 / sum).toFixed(2) + '%' : ctx.dataset.data[ctx.dataIndex].value;

										let label = ' ' + ctx.label +
											' ' + val || '';

										return label;
									}
								}
							},
							datalabels: {
								display: options.labels_type == 'datalabel',
								formatter: (value, ctx) => {
									let sum = 0;
									let dataArr = ctx.chart.data.datasets[0].data;

									dataArr.map(data => {
										sum += parseInt(data.value);
									});

									let percentage = (value.value*100 / sum).toFixed(2)+"%";

									let result = options.labels_scale == 'percentage' ? percentage : ctx.chart.data.datasets[0].data[ctx.dataIndex].value;

									return (result != '0.00%' && result != '0') ? result : ''

								},
								color: '#fff',
							},
						}
					},
					plugins: [ this.beforeInit ]
				};

				const chart = new Chart(el.getContext('2d'), config)
				charts.push(chart)
			}
		}


		// groupped bar charts
		const barCharts = document.querySelectorAll('.barChart')
		if (barCharts) {

			for (let el of barCharts) {
				const dataVar = el.getAttribute('data-var'),
					data = JSON.parse(JSON.stringify(window[dataVar].data)),
					options = JSON.parse(JSON.stringify(window[dataVar].options)),
					schema = {},
					type = 'bar-chart',
					filters = _this.defaultFilters

				_this.chartsData.push({
					dataVar,
					data, 
					options,
					schema,
					type,
					filters
				})

					
				let config = {
					type: 'bar',
					data: data,
					options: {
						grouped: true,
						responsive: true,
						maintainAspectRatio: false,
						plugins: {
							tooltip: {
								..._this.tooltipDefaultConfig
							},
							datalabels: {
								display: false,
							},
						},
						scales: {
							y: {
								beginAtZero: options.min ? false : true,
								suggestedMax: options.max ? Math.ceil(options.max) : false,
								suggestedMin: options.min ? options.min : 0,
								grid: {
									tickLength: 10,
									drawOnChartArea: true
								},
								ticks: {
									stepSize: options.step_size_y ? options.step_size_y : .5,
									precision: 0,
								}

							}
						}
					},
					plugins: [ this.beforeInit ]
				}

				const chart = new Chart(el.getContext('2d'), config);

				charts.push(chart);
			}
		}

		// simple bar charts
		const simpleBarCharts = document.querySelectorAll('.barChart-simple');
		if ( simpleBarCharts.length ) {

			for (let el of simpleBarCharts) {

				const dataVar = el.getAttribute('data-var'),
					data = JSON.parse(JSON.stringify(window[dataVar].data)),
					options = JSON.parse(JSON.stringify(window[dataVar].options)),
					schema = {},
					type = 'bar-chart-simple',
					filters = _this.defaultFilters

				_this.chartsData.push({
					dataVar,
					data, 
					options,
					schema,
					type,
					filters
				})

				// console.log('simpleBarCharts data', data)

				let config = {
					type: 'bar',
					data: data,
					options: {
						grouped: false,
						responsive: true,
						maintainAspectRatio: false,
						scales: {
							y: {
								// ticks: {
								beginAtZero: true,
								suggestedMax: options.max ? options.max : false,
								suggestedMin: options.min ? options.min : false,
								// grid: {
								// 	tickLength: 100,
								// 	drawOnChartArea: true,
								// },
								ticks: {
									stepSize: options.step_size_y ? options.step_size_y : .5,
									precision: 0,
								}
								// }
							},
							x: {
								beginAtZero: true,
								display: false
							}
							// x: {
							// 	grid: {
							// 		drawOnChartArea: false,
							// 	},
							// 	ticks: {
							// 		display: false
							// 	}
							// }
						},
						plugins: {
							datalabels: {
								display: false,
							},
						}
					},
					plugins: [ this.beforeInit ]
				};

				const chart = new Chart(el.getContext('2d'), config);

				charts.push(chart);
			}
		}



		const lineCharts = document.querySelectorAll('.lineChart');
		if ( lineCharts.length ) {
			for (const el of lineCharts) {

				const dataVar = el.getAttribute('data-var'),
					data = JSON.parse(JSON.stringify(window[dataVar].data)),
					options = JSON.parse(JSON.stringify(window[dataVar].options)),
					minDate = new Date(options.minDate * 1000),
					maxDate = new Date(options.maxDate * 1000),
					schema = {},
					type = 'line-chart',
					filters = _this.defaultFilters

				_this.chartsData.push({
					dataVar,
					data, 
					options,
					schema,
					type,
					filters
				})

				// console.log('lineCharts data', data);

				const config = {
					type: 'line',
					data: data,
					options: {
						responsive: true,
						plugins: {
							legend: {
								position: 'top',
							},

							tooltip: {
								..._this.tooltipDefaultConfig,
								callbacks: {
									title: _.bind( _this.tooltipTitleCallback, {options, _this} ),
									labelColor: function(context) {
										// console.log(context)
										return {
											borderColor: context.dataset.borderColor,
											backgroundColor: context.dataset.borderColor,
											borderWidth: 1,
											padding: 10,
											// borderDash: [2, 2],
											marginRight: 10,
										};
									},
									labelTextColor: function(context) {
										return '#fff';
									}
								}
							},
							datalabels: {
								display: false,
							},
						},
						maintainAspectRatio: false,
						scales: {
							x: {
								type : 'time',
								min: minDate,
								max: maxDate,
								time : {
									unit: options.period.unit,
									round: options.period.unit,
									displayFormats: _.bind( _this.chartDisplayFormat, {options} )
								},
								ticks: {
									callback: _.bind( _this.xTicksWeeksCallback, options )
								}
							},
							y: {
								beginAtZero: options.min ? false : true,
								suggestedMax: options.max,
								suggestedMin: options.min,
								grid: {
									tickLength: 10,
									drawOnChartArea: true
								},
								ticks: {
									stepSize: options.step_size_y ? options.step_size_y : 5,
									precision: 0,
								},

							}
						}
					},
					plugins: [ this.beforeInit ]
				};

				const chart = new Chart(el.getContext('2d'), config);

				charts.push(chart);
			}
		}

		const lineChartsCompound = document.querySelectorAll('.lineChartCompound');

		if ( lineChartsCompound.length ) {
			for (const el of lineChartsCompound) {

				const dataVar = el.getAttribute('data-var'),
					data = JSON.parse(JSON.stringify(window[dataVar].data)),
					options = JSON.parse(JSON.stringify(window[dataVar].options)),
					minDate = new Date(options.minDate * 1000),
					maxDate = new Date(options.maxDate * 1000),
					schema = {},
					type = 'line-chart-compound',
					filters = _this.defaultFilters

				_this.chartsData.push({
					dataVar,
					data, 
					options,
					schema,
					type,
					filters
				})

				const config = {
					type: 'line',
					data: data,
					options: {
						responsive: true,
						plugins: {
							legend: {
								position: 'top',
							},
							tooltip: {
								..._this.tooltipDefaultConfig,
								callbacks: {
									title: _.bind( _this.tooltipTitleCallback, {options, _this} ),
									labelColor: function(context) {
										// console.log('context::', context)
										return {
											borderColor: context.dataset.borderColor,
											backgroundColor: context.dataset.borderColor,
											fillColor: context.dataset.borderColor,
											borderWidth: 1,
											padding: 10,
											// borderDash: [2, 2],
											marginRight: 10,
										};
									},
									labelTextColor: function(context) {
										return '#fff';
									}
								}
							},
							datalabels: {
								display: false,
							},
						},
						maintainAspectRatio: false,
						scales: {
							x: {
								type : 'time',
								min: minDate,
								max: maxDate,

								time : {
									unit: options.period.unit,
									round: options.period.unit,
									displayFormats: _.bind( _this.chartDisplayFormat, {options} )
								},
								ticks: {
									callback: _.bind( _this.xTicksWeeksCallback, options )
								}
							},
							y: {
								beginAtZero: options.min ? false : true,
								suggestedMax: options.max,
								suggestedMin: options.min,
								grid: {
									tickLength: 10,
									drawOnChartArea: true
								},
								ticks: {
									stepSize: options.step_size_y ? options.step_size_y : 5,
									precision: 0
								}
							}
						}
					}
				}

				const chart = new Chart(el.getContext('2d'), config);

				charts.push(chart);
			}
		}


		const areaChartsStacked = document.querySelectorAll('.areaChartStacked');

		if ( areaChartsStacked.length ) {
			for (const el of areaChartsStacked) {
				const dataVar = el.getAttribute('data-var'),
					data = JSON.parse(JSON.stringify(window[dataVar].data)),
					options = JSON.parse(JSON.stringify(window[dataVar].options)),
					minDate = new Date(options.minDate * 1000),
					maxDate = new Date(options.maxDate * 1000),
					schema = {},
					type = 'area-chart-stacked',
					filters = _this.defaultFilters

				_this.chartsData.push({
					dataVar,
					data, 
					options,
					schema,
					type,
					filters
				})

				// console.log(options.period.format);
				// console.log('reference dataset', data);
				// let chartsLocaleData = _this.getChartsLocale()

				const config = {
					type: 'line',
					data: data,
					options: {
						responsive: true,
						interaction: {
							intersect: false,
						},
						pointBackgroundColor: '#fff',
						// parsing: {
						// 	xAxisKey: 'data\\.labels',
						// },
						// radius: 4,
						plugins: {
							legend: {
								position: 'top',
							},

							filler: {
								propagate: true,
							},

							tooltip: {
								..._this.tooltipDefaultConfig,

								callbacks: {
									title: _.bind( _this.tooltipTitleCallback, {options, _this} ),
									labelColor: function(context) {
										// console.log()
										return {
											borderColor: context.dataset.borderColor,
											backgroundColor: context.dataset.backgroundColor,
											borderWidth: 0,
											// borderDash: [2, 2],
											borderRadius: 0,
											marginRight: 10,
										};
									},
									labelTextColor: function(context) {
										return '#fff';
									}
								}
							},
							datalabels: {
								display: false,
							},
						},
						maintainAspectRatio: false,
						scales: {
							x: {
								type : 'time',
								min: minDate,
								max: maxDate,

								time : {
									unit: options.period.unit,
									round: options.period.unit,
									displayFormats: _.bind( _this.chartDisplayFormat, {options} )
								},
								ticks: {
									callback: _.bind( _this.xTicksWeeksCallback, options )
								}
							},
							y: {
								beginAtZero: true,
								suggestedMax: options.max ? options.max : false,
								suggestedMin: options.min,
								stacked: true,
								grid: {
									tickLength: 10,
									drawOnChartArea: true
								},
								ticks: {
									stepSize: options.step_size_y ? options.step_size_y : .5,
									precision: 0,
								}
							}
						}
					},
					plugins: [ this.beforeInit ]
				}

				// console.log('areaChartsStacked config:', config);

				const chart = new Chart(el.getContext('2d'), config);

				charts.push(chart);
			}
		}

		const barChartsStacked = document.querySelectorAll('.barChart-stacked');
		if ( barChartsStacked.length ) {
			for (let el of barChartsStacked) {
				const dataVar = el.getAttribute('data-var'),
					data = JSON.parse(JSON.stringify(window[dataVar].data)),
					options = JSON.parse(JSON.stringify(window[dataVar].options)),
					minDate = new Date(options.minDate * 1000),
					maxDate = new Date(options.maxDate * 1000),
					schema = {},
					type = 'bar-chart-stacked',
					filters = _this.defaultFilters

				_this.chartsData.push({
					dataVar,
					data, 
					options,
					schema,
					type,
					filters
				})

				// console.log('barChartsStacked', data);

				let scalesConfig = {
					x : {
						stacked : true
					}
				};

				// console.log('reference data set', data);


				if(options.x_axis === 'time' && options.y_axis === 'percentage') {
					scalesConfig.x = {
						type : 'time',
						min: minDate,
						max: maxDate,
						stacked : true,
						time : {
							unit: options.period.unit,
							round: options.period.unit,
							displayFormats: _.bind( _this.chartDisplayFormat, {options} )
						},
						ticks: {
							callback: _.bind( _this.xTicksWeeksCallback, options )
						}
					}
					scalesConfig.y = {
						beginAtZero: true,
						suggestedMax: 100,
						suggestedMin: options.min,
						stacked: true,
						grid: {
							tickLength: 10,
							drawOnChartArea: true
						},
						ticks: {
							stepSize: 20,
							precision: 0,
							callback: function (value) {
								return value + '%'; // convert it to percentage
							}
						}
					}

				} else if(options.x_axis === 'time' && options.y_axis === 'numbers') {

					scalesConfig.x = {
						type : 'time',
						stacked : true,
						min: minDate,
						max: maxDate,
						time : {
							unit: options.period.unit,
							round: options.period.unit,
							displayFormats: _.bind( _this.chartDisplayFormat, {options} )
						},
						ticks: {
							callback: _.bind( _this.xTicksWeeksCallback, options )
						}
					}
					scalesConfig.y = {
						beginAtZero: true,
						suggestedMax: options.max ? options.max : false,
						suggestedMin: options.min,
						stacked: true,
						grid: {
							tickLength: 10,
							drawOnChartArea: true
						},
						ticks: {
							stepSize: options.step_size_y ? options.step_size_y : .5,
							precision: 0,
							callback: function (value) {
								return value
							},
						}
					}
				} else if(options.x_axis === 'groups' && options.y_axis === 'percentage') {
					scalesConfig.y = {
						stacked: true,
						suggestedMax: 100,
						ticks: {
							stepSize: 20,
							min: 0,
							max: this.max,// Your absolute max value
							callback: function (value) {
								return value + '%'; // convert it to percentage
							},
							// precision: 0,

						},
						scaleLabel: {
							display: true,
							labelString: 'Percentage',
						}
					}
				} else if(options.x_axis === 'groups' && options.y_axis === 'numbers') {
					scalesConfig.y = {
						beginAtZero: true,
						suggestedMax: options.max ? options.max : false,
						suggestedMin: options.min,
						stacked: true,
						grid: {
							tickLength: 10,
							drawOnChartArea: true
						},
						ticks: {
							stepSize: options.step_size_y ? options.step_size_y : .5,
							precision: 0,
							callback: function (value) {
								return value; // convert it to percentage
							},
						}
					};
				}


				let config = {
					type: 'bar',
					data: data,
					options: {
						responsive: true,
						maintainAspectRatio: false,
						plugins: {
							tooltip: {
								..._this.tooltipDefaultConfig,
								callbacks: {
									title: _.bind( _this.tooltipTitleCallback, {options, _this} ),
									label: function(context) {
										let label = context.dataset.label + ' ' + context.dataset.data[context.dataIndex].y || '';
										return (options.y_axis === 'percentage') ? label + '%' : label + ''
									}
								}
							},
							datalabels: {
								display: false,
							},
						},
						scales: scalesConfig
					},
					plugins: [ this.beforeInit ]
				}

				// console.log('barChartsStacked config:', config);

				const chart = new Chart(el.getContext('2d'), config);

				charts.push(chart);
			}
		}

		const radarCharts = document.querySelectorAll('.radarChart');
		if ( radarCharts.length ) {
			for (let el of radarCharts) {

				const dataVar = el.getAttribute('data-var'),
					data = window[dataVar].data,
					options = window[dataVar].options,
					schema = {},
					type = 'radar-chart',
					filters = _this.defaultFilters

				_this.chartsData.push({
					dataVar,
					data, 
					options,
					schema,
					type,
					filters
				})

				data.datasets == null || data.datasets.length == 0 || data.datasets.map( el => {
					el.backgroundColor = _this.transparentize(el.backgroundColor, .5)

					return el

				})

				const config = {
					type: 'radar',
					data: data,
					options: {
						responsive: true,
						maintainAspectRatio: false,
						legend: {
							// position: 'right',
						},
						plugins: {
							tooltip: {
								..._this.tooltipDefaultConfig
							},
							datalabels: {
								display: false,
							},
						},
						scales: {
							r: {
								ticks: {
									stepSize: options.step_size_y,
									precision: 0,
								}
							}
						}
					},
					plugins: [ this.beforeInit ]
				};

				const chart = new Chart(el.getContext('2d'), config)
			}
		}

		const barlineCharts = document.querySelectorAll('.barlineChart');
		if ( barlineCharts.length ) {
			for (let el of barlineCharts) {
				const dataVar = el.getAttribute('data-var'),
					data = JSON.parse(JSON.stringify(window[dataVar].data)),
					options = JSON.parse(JSON.stringify(window[dataVar].options)),
					minDate = new Date(options.minDate * 1000),
					maxDate = new Date(options.maxDate * 1000),
					schema = {},
					type = 'bar-line-chart',
					filters = _this.defaultFilters

				_this.chartsData.push({
					dataVar,
					data, 
					options,
					schema,
					type,
					filters
				})

				data.datasets == null || data.datasets.length == 0 || data.datasets.map( el => {
					// console.log('el::', el)
					if ( el.type == 'bar' ) {
						el.backgroundColor = _this.transparentize(el.backgroundColor, .5)
					}

					return el
				})

				window[dataVar].data = data

				let suggestedMin = window[dataVar].options.from,
					suggestedMax = window[dataVar].options.to,
					stepSize = window[dataVar].options.step_size_y;

				// console.log('maxDate', maxDate)

				const config = {
					type: 'bar',
					data: data,
					options: {
						responsive: true,
						maintainAspectRatio: false,
						legend: {
							// position: 'right',
						},
						plugins: {
							tooltip: {
								..._this.tooltipDefaultConfig,
								callbacks: {
									title: _.bind( _this.tooltipTitleCallback, {options, _this} )
								}
							},
							datalabels: {
								display: false,
							},
						},
						scales: {
							x: {
								type : 'time',
								min: minDate,
								max: maxDate,
								time : {
									unit: options.period.unit,
									round: options.period.unit,
									displayFormats: _.bind( _this.chartDisplayFormat, {options} )
								},

								ticks: {
									callback: _.bind( _this.xTicksWeeksCallback, options )
								}
							},
							y: {
								beginAtZero: options.min ? false : true,
								suggestedMax: options.max,
								suggestedMin: options.min,
								grid: {
									tickLength: 10,
									drawOnChartArea: true,
								},
								ticks: {
									stepSize: stepSize,
									precision: 0,
								}

							}

						}
					},
					plugins: [ this.beforeInit ]
				};

				const chart = new Chart(el.getContext('2d'), config);

				charts.push(chart);
			}
		}

		// groupped bar charts
		const histogramCharts = document.querySelectorAll('.histogramChart');
		if (histogramCharts) {
			for (let el of histogramCharts) {
				const dataVar = el.getAttribute('data-var'),
					data = JSON.parse(JSON.stringify(window[dataVar].data)),
					options = JSON.parse(JSON.stringify(window[dataVar].options)),
					schema = {},
					type = 'histogram-chart',
					filters = _this.defaultFilters

				_this.chartsData.push({
					dataVar,
					data, 
					options,
					schema,
					type,
					filters
				})


				let config = {
					type: 'bar',
					data: data,
					options: {
						responsive: true,
						maintainAspectRatio: false,
						plugins: {
							tooltip: {
								..._this.tooltipDefaultConfig
							},
							datalabels: {
								display: false,
							},
						},
						scales: {
							y: {
								beginAtZero: options.min ? false : true,
								// weight: 1,
								suggestedMax: options.max ? Math.ceil(options.max) : false,
								suggestedMin: options.min ? options.min : 0,
								// offset: 1
								grid: {
									tickLength: 10,
									drawOnChartArea: true
								},
								ticks: {
									stepSize: options.step_size_y,
									precision: 0,
								}

							},

							x: {
								display: false,
								barPercentage: 1.3,
								ticks: {
									max: 5,
								}
							},
							x2: {
								display: true,
								ticks: {
									autoSkip: false,
									max: 4,
								}
							}
						}
					},
					plugins: [ this.beforeInit ]
				};

				const chart = new Chart(el.getContext('2d'), config);
			}
		}

	}

	tooltipRender() {
		const vuedash = document.getElementsByClassName('dashboard-grid-container-vue')
		if ( vuedash.length ) return 
		// setTimeout( function() {
			const buttons = document.getElementsByClassName('tooltip-btn')
			// console.log('buttons::', buttons)
			// for ( let el of buttons ) {
			Array.from(buttons).forEach(el => {
				console.log('el::', el)
				tippy(el, {
				  	content: el.nextElementSibling.innerHTML,
				  	theme: 'bryter',
				  	arrow: tippy.roundArrow,
				  	// hideOnClick: false,
				  	// trigger: 'click',
				  	placement: 'right',
				});	
			})
		// }, 500)
	}

	transparentize(value, opacity) {
		var alpha = opacity === undefined ? 0.5 : 1 - opacity;
		return colorLib(value).alpha(alpha).rgbString();
	}

	getDateFormat(period) {
		if(period === 'week') {
			const pairs = {
				'DD-MM-YYYY': 'dd-MM-yyyy',
				'MM-DD-YYYY': 'MM-dd-yyyy',
				'YYYY-MM-DD': 'yyyy-MM-dd',
				'DD/MM/YYYY': 'dd/MM/yyyy',
				'MM/DD/YYYY': 'MM/dd/yyyy',
				'DD.MM.YYYY': 'dd.MM.yyyy',
				'D MMMM YYYY': 'd MMMM yyyy',
			}

			return pairs[date_format];
		} else if(period === 'month') {
			const pairs = {
				'DD-MM-YYYY': 'MM-yyyy',
				'MM-DD-YYYY': 'MM-yyyy',
				'YYYY-MM-DD': 'yyyy-MM',
				'DD/MM/YYYY': 'MM/yyyy',
				'MM/DD/YYYY': 'MM/yyyy',
				'DD.MM.YYYY': 'MM.yyyy',
				'D MMMM YYYY': 'MMMM yyyy',
			}

			return pairs[date_format];
		} else if(period === 'year') {
			return 'yyyy';
		} else {
			const pairs = {
				'DD-MM-YYYY': 'dd-MM-yyyy',
				'MM-DD-YYYY': 'MM-dd-yyyy',
				'YYYY-MM-DD': 'yyyy-MM-dd',
				'DD/MM/YYYY': 'dd/MM/yyyy',
				'MM/DD/YYYY': 'MM/dd/yyyy',
				'DD.MM.YYYY': 'dd.MM.yyyy',
				'D MMMM YYYY': 'd MMMM yyyy',
			}

			return pairs[date_format];
		}
	}

	getDatePair() {
		const pairs = {
			'DD-MM-YYYY': 'dd-MM-yyyy',
			'MM-DD-YYYY': 'MM-dd-yyyy',
			'YYYY-MM-DD': 'yyyy-MM-dd',
			'DD/MM/YYYY': 'dd/MM/yyyy',
			'MM/DD/YYYY': 'MM/dd/yyyy',
			'DD.MM.YYYY': 'dd.MM.yyyy',
			'D MMMM YYYY': 'd MMMM yyyy',
		}

		return pairs[date_format];
	}

	parseDate(input) {
		return parse(input, this.getDatePair(), new Date());
	}

	turnIntoValidDate(input) {
		return parseISO(input);
	}

	getChartsLocale() {
		let calendarLocaleDataset = localeEn;

		switch (window.charts_locale) {
			case 'en':
				calendarLocaleDataset = localeEn;
				break;
			case 'es':
				calendarLocaleDataset = localeEs;
				break;
			case 'de':
				calendarLocaleDataset = localeDe;
				break;
			case 'it':
				calendarLocaleDataset = localeIt;
				break;
			case 'fr':
				calendarLocaleDataset = localeFr;
				break;
			default:
				calendarLocaleDataset = localeEn;
		}

		return calendarLocaleDataset;
	}

	initDatepickers() {
		const _this = this;

		const datepickers = $('.datepicker-container');

		if(datepickers.length > 0) {
			datepickers.each(function () {
				const datepicker = $(this);
				const period = datepicker.data('chart-period');

				let startDateID = datepicker.find('.start-date').attr('id'),
					defaultStartDate = _this.parseDate(datepicker.find('.start-date').val()),
					startDate = _this.parseDate(datepicker.find('.start-date').val()),
					endDate = _this.parseDate(datepicker.find('.end-date').val()),
					defaultEndDate = _this.parseDate(datepicker.find('.end-date').val()),
					endDateId = datepicker.find('.end-date').attr('id');

				let startConfig = {
					locale: _this.getChartsLocale(),
					startDate: startDate,
					maxDate: endDate,
					dateFormat: _this.getDatePair(),
					selectedDates: startDate,
					autoClose: true,
					onSelect({date}) {
						// console.log('startDateValue', date, _this.getDatePair())
						let startDateValue = format(date, _this.getDatePair());
						let endDate = _this.parseDate(datepicker.find('.end-date').val());

						if(period === 'month') {
							endDate = endOfMonth(_this.turnIntoValidDate(datepicker.find('.end-date').val()));
						} else if(period === 'year') {
							endDate = endOfYear(_this.turnIntoValidDate(datepicker.find('.end-date').val()));
						}

						startDate = _this.parseDate(startDateValue)

						start.update({
							startDate: startDate,
							onRenderCell({date, cellType}) {
								if (cellType === 'day') {
									if ((date > startDate) && (date < endDate) ) {
										return {
											classes: '-in-range-'
										}
									}
								}
							}
						});

						if($('.bryter-dt').length > 0) {
							window.filters.params['time-interval'] = format(date, 'yyyyMMdd') + '|' + format(end.lastSelectedDate, 'yyyyMMdd');
							$(document).trigger('startDateOnSelect', date);
						}

						_this.filterDate(datepicker, startDate, endDate);
					},
					onRenderCell({date, cellType}) {
						// Disable all 12th dates in month
						if (cellType === 'day') {
							if ((date > startDate) && (date < endDate) ) {
								return {
									classes: '-in-range-'
								}
							}
						}
					}
				};

				let endConfig = {
					locale: _this.getChartsLocale(),
					dateFormat: _this.getDatePair(),
					endDate: endDate,
					maxDate: endDate,
					selectedDates: endDate,
					autoClose: true,
					position: 'bottom right',
					onSelect({date}) {
						let endDate = date;

						if(period === 'month') {
							endDate = endOfMonth(date);
						} else if(period === 'year') {
							endDate = endOfYear(date);
						}

						end.update({
							endDate: endDate,
							onRenderCell({date, cellType}) {
								if (cellType === 'day') {
									if ((date > startDate) && (date < endDate) ) {
										return {
											classes: '-in-range-'
										}
									}
								}
							}
						});

						if($('.bryter-dt').length > 0) {
							window.filters.params['time-interval'] = format(start.lastSelectedDate, 'yyyyMMdd') + '|' + format(date, 'yyyyMMdd');

							$(document).trigger('endDateOnSelect', date);
						}

						_this.filterDate(datepicker, startDate, endDate);
					},
					onRenderCell({date, cellType}) {
						// Disable all 12th dates in month
						if (cellType === 'day') {
							if ((date > startDate) && (date < endDate) ) {
								return {
									classes: '-in-range-',
								}
							}
						}
					}
				}

				if(period === 'month') {
					startConfig.view = 'months';
					startConfig.minView = 'months';
					startConfig.dateFormat = _this.getDateFormat(period);

					endConfig.view = 'months';
					endConfig.minView = 'months';
					endConfig.dateFormat = _this.getDateFormat(period)
				} else if(period === 'year') {
					startConfig.view = 'years';
					startConfig.minView = 'years';
					startConfig.dateFormat = 'yyyy';

					endConfig.view = 'years';
					endConfig.minView = 'years';
					endConfig.dateFormat = 'yyyy';
				}

				let start = new AirDatepicker('#' + startDateID, startConfig);
				let end = new AirDatepicker('#' + endDateId, endConfig);

				window['dp'][startDateID] = start;
				window['dp'][endDateId] = end;

			});

			$(document).on('resetDatePickers', function(event, data) {
				

				let startDateID = 'start_date_' + $(data.element).data('dt-id'),
					endDateID = 'end_date_' + $(data.element).data('dt-id');

				const datepicker = $(`#${startDateID}`).parent().parent(),
					period = datepicker.data('chart-period');


				let 
					defaultStartDate = _this.parseDate(datepicker.find('.start-date').attr('value')),
					startDate = _this.parseDate(datepicker.find('.start-date').attr('value')),
					endDate = _this.parseDate(datepicker.find('.end-date').attr('value')),
					defaultEndDate = _this.parseDate(datepicker.find('.end-date').attr('value'))

				// let start = new AirDatepicker('#start_date_' + $(data.element).data('dt-id')),
					// end = new AirDatepicker('#end_date' +  $(data.element).data('dt-id'), endConfig);

				let start = window['dp'][startDateID],
					end = window['dp'][endDateID]

				start.clear();
				start.selectDate(defaultStartDate);
				end.clear();
				end.selectDate(defaultEndDate);
			});
		}
	}



	filterDate(datepicker, startDate, endDate) {
		// console.log('filterDate()', startDate, endDate);
		const _this = this;

		const parent = datepicker.parents('.Card');

		if(!parent) return;

		const currentChart = parent.find('canvas'),
			chartId = currentChart.attr('id');

		charts.forEach((chart, index) => {
			if(chartId === chart.canvas.id) {

				const chartType = charts[index].config.type,
					chartTypes = ['pie', 'doughnut', 'bar'];

				if(chartTypes.includes(chartType)) {
					const currentChart = parent.find('canvas'),
						key = currentChart.data('date-filter-column'),
						dataVar = currentChart.data('var')
					
					'undefined' == typeof endDate || endDate.setHours(23,59,59,999);
					// _this.removeData(index, dataVar, key, [startDate, endDate], 'date');

					let myIndex = _this.chartsData.findIndex( item => item.dataVar == dataVar )
					_this.chartsData[myIndex].filters.date = {
						key,
						value: [startDate, endDate]
					}

					if(currentChart.data('chart-x-axis') && currentChart.data('chart-x-axis') === 'time') {
						charts[index].config.options.scales.x.min = startDate;
						charts[index].config.options.scales.x.max = endDate;
					}


					_this.filterChartAction(myIndex, dataVar, key)

				} else {
					charts[index].config.options.scales.x.min = startDate;
					charts[index].config.options.scales.x.max = endDate;
				}

				charts[index].update();
			}
		});
	}

	filterSelect() {
		const _this = this;

		$('.submit-chart-filter, .reset-chart-filter').click(function (e) {
			const parent = $(this).parents('.Card'),
				el = $(this).parents('.dropdown-chart-filter');

			const form = el.find('form'),
				key = form.data('column'),
				value = form.find('input[name="' + key + '"]:checked').val(),
				currentChart = parent.find('canvas'),
				chartId = currentChart.attr('id'),
				dataVar = currentChart.data('var');

			// charts.forEach((chart, index) => {
			// 	if(chartId === chart.canvas.id) {
					let myIndex = _this.chartsData.findIndex( item => item.dataVar == dataVar )
					if($(this).hasClass('reset-chart-filter')) {
						// console.log('filterSelect', $(this))
						_this.chartsData[myIndex].filters.dropdown = null
						_this.chartsData[myIndex].filters.date = null
						_this.removeData(myIndex, dataVar, key, null, 'reset');
						_this.removeFilterCounter(el, key);
					} else {
						// console.warn(index, dataVar, key, null);
						// _this.removeData(index, dataVar, key, value, 'dropdown');
						
						_this.chartsData[myIndex].filters.dropdown = { key, value }
						_this.filterChartAction(myIndex, dataVar, key)
						_this.addFilterCounter(el, key);
					}
			// 	}
			// });
		});
	}


	filterChartAction( index, dataVar ) {
		// console.log('current chart filters::', dataVar, this.chartsData[index].filters.date.key, this.chartsData[index].filters)

		console.log(this.chartsData[index].filters.date )
		this.removeData(index, dataVar, null, null, 'reset');
		if ( null != this.chartsData[index].filters.dropdown ) {
			this.removeData(index, dataVar, this.chartsData[index].filters.dropdown.key, this.chartsData[index].filters.dropdown.value, 'dropdown');
		}
		if ( null != this.chartsData[index].filters.date ) {
			this.removeData(index, dataVar, this.chartsData[index].filters.date.key, this.chartsData[index].filters.date.value, 'date');
		}
	}

	removeData(index, dataVar, key, value, type) {

		let mycharts = this.chartsData.filter( item => item.dataVar == dataVar ),
			myIndex = this.chartsData.findIndex( item => item.dataVar == dataVar )

		if ( ! mycharts.length && ! 'reset' != type ) return false;

		// console.log('myindex::',  myIndex )
		// console.log('type::',  type )
		// console.log('value::',  value )
		
		// charts[index].data.datasets = JSON.parse(JSON.stringify(window[dataVar].data.datasets));
		// charts[index].data.datasets = JSON.parse(JSON.stringify(mycharts[0].data.datasets))

		let originalDatasets = type == 'reset' ? JSON.parse( JSON.stringify( window[dataVar].data.datasets ) ) : mycharts[0].data.datasets

		// console.log(charts)
		// console.log('originalDatasets::', originalDatasets)
		// charts[index].data.datasets = charts[index].data.datasets.map( (dataset, dsIndex) => {
		charts[index].data.datasets = originalDatasets.map( ( dataset, dsIndex ) => {
			
			// console.log('this should run a single time', index);
			// if(index !== dsIndex) return;
			let result = dataset
			
			if(!value) return result;

			
			// console.log('this should run the <number of datasets> times', window[dataVar].data.datasets.length);


			/*
			 * If date_filter_column is used
			 */
			if(type && type === 'date') {
				const startDate = value[0];
				const endDate = value[1];

				// console.log(index, charts[index]);

				result.data = dataset.data.map( (data, index) => {
					if ( data.y > 0 ) {
						data.items = data.items.map( item => {
							const isDateWithinInterval = isWithinInterval(parseISO(item[key]), { start: startDate, end: endDate });

							if(isDateWithinInterval) {
								return item;
							} else {
								// console.log('isWithinInterval::', isDateWithinInterval, item[key], parseISO(item[key]), { start: startDate, end: endDate })
								data.y -= 1;
							}
						})
					} else if ( data.data ) {
						data.data = data.data.map( item => {
							const isDateWithinInterval = isWithinInterval(parseISO(item[key]), { start: startDate, end: endDate });

							if(isDateWithinInterval) {
								return item;
							} else {
								data.value -= 1;
							}
						});
					}


					return data;
				})

				return result;

			/*
			 *	Else if we have dates on the x-axis
			 */
			} else {
				result.data = dataset.data.map( (data, index) => {
					if ( data.y > 0 ) {
						data.items = data.items.map( item => {
							if ( item[key] !== value ) {
								if ( 'percentage' == window[dataVar].options.y_axis ) {
									let y_real_new  = data.y_real > 1 ? data.y_real - 1 : 0
									data.y = ( 0 == data.y_real ) ? 0 : ( y_real_new * data.y ) / data.y_real
									data.y_real = y_real_new
								} else {
									data.y -= 1
								}
							} else {
								return item
							}
						})
					} else if(data.value > 0) {
						data.data = data.data.map( item => {
							if ( item[key] !== value ) {
								data.value -= 1
							} else {
								return item
							}
						})
					}

					return data
				})

				return result
			}
		})

		this.chartsData[myIndex].data.datasets = charts[index].data.datasets

		charts[index].update();
	}

	addFilterCounter(el, key) {
		if ( !el.find('.filters-count').length ) {
			el.find('.summary-label').prepend('<span class="filters-count">1</span> ')
		}
	}

	removeFilterCounter(el, key) {
		el.find('.filters-count').remove();
	}

	xTicksWeeksCallback(value, index, values) {
		if(this.period.unit === 'week') {
			return `W${value}`;
		} else {
			return value;
		}
	}

	tooltipTitleCallback(context) {
		let unit = this.options.period.unit		
		let chartsLocaleData = this._this.getChartsLocale()
		// console.log('chartsLocaleData::', chartsLocaleData.dateFormat, context[0].raw.x)
		// console.log() 
		return (unit == 'week' ? 'W' : '') + 
			format(
				parse(
					context[0].raw.x, 
					// chartsLocaleData.dateFormat,
					'yyyy-MM-dd',
					new Date(context[0].parsed.x) 
				), 
				this.options.period.format[unit]
				// { locale: localeEn }
			)
	}

	chartDisplayFormat() {
		return {
			day: this.options.period.format['day'],
			week: this.options.period.format['week'],
			month: this.options.period.format['month'],
			year: this.options.period.format['year'],
		}
	}
}
(function ($) {


	/**
	 * Init Dashboard
	 */
	window.addEventListener('DOMContentLoaded', ($) => {
		new DashboardView

		// new DashboardView();
	});
})($);